import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import SideBarArrow from '../img/SideBarArrow.svg';

const AnalyticsButton = ({ isAnyModalOpen }) => {
  const location = useLocation();

  const isActive =
    location.pathname.split('/')[1] === 'wazuh-analytics' && !isAnyModalOpen;

  return (
    <Link to='/wazuh-analytics' className='flex items-center'>
      {isActive && (
        <img
          alt='blue-arrow'
          className='relative right-4 w-1'
          src={SideBarArrow}
        />
      )}
      <button
        className={`${
          isActive ? 'relative right-1 text-blue-500' : 'text-gray-800'
        } flex  dark:text-white hover:text-blue-500 items-center my-4`}
      >
        Sales Analytics
      </button>
    </Link>
  );
};

export default AnalyticsButton;
